// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-text[data-v-dde3c820] {\n  white-space: -moz-nowrap; /* Firefox */\n  white-space: -o-nowrap; /* Opera */\n  white-space: nowrap; /* Chrome */\n  word-wrap: break-word; /* IE */\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
